import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { Globals } from 'app/_globals';
import { NotificationService } from 'app/_services/notification.service';
import { SiteService } from 'app/_services/site.service';
import { TrainingService } from 'app/_services/training.service';

@Component({
  selector: 'app-site-details',
  templateUrl: './site-details.component.html'
})
export class SiteDetailsComponent implements OnInit {
  public selectedSite: any;
  private selectedSiteId: number;

  public siteDetailsForm: FormGroup;

  public selectedInduction: any;
  public availableInductions: any[] = [];

  private routeRole: any;
  public showWindFarmFields: boolean;
  public isSiteDelegate: boolean;
  public isPowerStationUser: boolean;

  constructor(
    private siteService: SiteService,
    private globals: Globals,
    private activatedRoute: ActivatedRoute,
    private trainingService: TrainingService,
    private notificationService: NotificationService,
    fb: FormBuilder,
  ) {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.selectedSiteId = parseInt(params.id);
    });

    this.routeRole = globals.user.routeRole;
    this.isPowerStationUser = this.routeRole === 'power-station-owner' || this.routeRole === 'power-station-manager';
    this.showWindFarmFields = !this.isPowerStationUser;
    this.isSiteDelegate = this.routeRole === 'site-delegate';

    this.siteDetailsForm = fb.group({
      name: new FormControl(),
      mainContactNumber: new FormControl(),
      emergencyContactNumber: new FormControl(),
      altEmergencyContactNumber: new FormControl(),
      description: new FormControl(),
      waypointInterval: new FormControl(),
      // induction select works separately to form
    });
  }

  ngOnInit() {
    this.getSelectedSite(this.selectedSiteId);
  }

  private getSelectedSite(id) {
    this.siteService.getSiteById(id).subscribe((data: any) => {
      this.selectedSite = data;

      if (!this.isSiteDelegate) {
        this.getAllSiteInductionsByOwner(this.globals.user.id);

        if (!!this.selectedSite.siteInductionCourse) {
          this.selectedInduction = {
            label: this.selectedSite.siteInductionCourse.name,
            value: this.selectedSite.siteInductionCourse.id
          };
        }
      }

      this.assignFormValues();
    });
  }

  private getAllSiteInductionsByOwner(id) {
    this.availableInductions = [];
    this.trainingService.getTrainingCoursesBySiteOwnerId(id).subscribe((data: any) => {
      const inductions = data.filter(course => course.courseType === 'INDUCTION');

      inductions.forEach(element => {
        const obj = {
          label: element.name,
          value: element.id
        };
        this.availableInductions.push(obj);
      });
    });
  }

  private assignFormValues() {
    this.siteDetailsForm.patchValue({
      name: this.selectedSite.name,
      description: this.selectedSite.description,
      emergencyContactNumber: this.selectedSite.emergencyContactNumber,
      altEmergencyContactNumber: this.selectedSite.altEmergencyContactNumber,
      waypointInterval: this.selectedSite.healthCheckInterval,
    });

    if (this.selectedSite.mainContactNumber !== null) {
      this.siteDetailsForm.patchValue({
        mainContactNumber: this.selectedSite.mainContactNumber
      })
    } else {
      this.siteDetailsForm.patchValue({
        mainContactNumber: ''
      })
    }
  }

  public onSiteDetailsFormSubmit() {
    const values = this.siteDetailsForm.value;
    const newDetails = {
      name: values.name,
      mainContactNumber: values.mainContactNumber,
      emergencyContactNumber: values.emergencyContactNumber,
      altEmergencyContactNumber: values.altEmergencyContactNumber,
      description: values.description,
      healthCheckInterval: values.waypointInterval,
      addAssetCompetencies: values.addAssetCompetencies,
    };

    const body = this.siteService.createRequestBodyForEditingSite(this.selectedSite, newDetails);

    this.siteService.editSiteDetails(body).subscribe((data: any) => {
      this.getSelectedSite(this.selectedSiteId);
      this.notificationService.notify('success', 'Success', 'Site Details Updated');
    });
  }

  public removeInduction() {
    this.trainingService.removeInductionFromSite(this.selectedSiteId, this.selectedInduction.value).subscribe((data: any) => {
      this.selectedInduction = null;
      this.getSelectedSite(this.selectedSiteId);
      this.notificationService.notify('success', 'Success', 'Site Induction Removed');
    });
  }

  public onSelectedSiteInductionChange(event) {
    this.trainingService.addInductionToSite(this.selectedSiteId, event.value).subscribe((data: any) => {
      this.getSelectedSite(this.selectedSiteId);
      this.notificationService.notify('success', 'Success', 'Site Induction Updated');
    });
  }
}
